import state from "./moduleMailSentStates";
import mutations from "./moduleMailSentMutations";
import actions from "./moduleMailSentActions";
import getters from "./moduleMailSentGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}